import {BehaviorSubject} from 'rxjs';

export type Language = 'pl' | 'en' | 'lt' | 'pt' | 'fr' | '';

export abstract class AbstractLanguageService {
  showLanguagePicker!: boolean;

  currentLanguage$!: BehaviorSubject<Language>;
}
